const PropTypes = require('prop-types');
const React = require('react');
const CSRFForm = require('components/shared/csrf_form.jsx');
const BankAccountFields = require('components/shop/direct_checkout_profile/bank_account_fields.jsx');

const bankAccountFieldsPropsWithDefaults = (props) =>
  Object.assign(
    {},
    props,
    {
      onCountryChange: () => null,
      onCurrencyChange: () => null,
      dashboardView: false,
    }
  );

const BankAccountForm = (props) =>
  <CSRFForm
    method="PUT"
    action={props.saveBankAccountUrl}
  >
    <BankAccountFields {...bankAccountFieldsPropsWithDefaults(props.bankAccountFieldsProps)} />
    <button
      className="btn btn-primary scaling-mt-1"
      type="submit"
    >
      {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.save')}
    </button>
  </CSRFForm>;

BankAccountForm.propTypes = {
  saveBankAccountUrl: PropTypes.string.isRequired,
  bankAccountFieldsProps: PropTypes.shape({
    fieldsNamePrefix: PropTypes.string.isRequired,
    bankLookupUrl: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    countryCodeOptions: PropTypes.array.isRequired,
    currencies: PropTypes.object,
    selectedPayoutCurrency: PropTypes.string.isRequired,
    shopCurrency: PropTypes.string.isRequired,
    hasLayawayEnabled: PropTypes.bool.isRequired,
  }),
};

module.exports = BankAccountForm;



// WEBPACK FOOTER //
// ./javascripts/components/bank_transfer_requests/bank_account_form.jsx